var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "price-input-section" }, [
      _c(
        "div",
        {
          staticClass: "price-wrapper",
          class: { "form-error": _vm.validation.amount.$error }
        },
        [
          _c("AppInput", {
            attrs: {
              label: `${_vm.$t("Price")}(${_vm.getCurrencySymbol(
                _vm.currency
              )}) *`,
              "input-class": "mb-1",
              placeholder: "",
              type: "number",
              hasPrecision: "",
              dataTestId: "price-input"
            },
            on: { blur: _vm.validation.$touch },
            model: {
              value: _vm.value.amount,
              callback: function($$v) {
                _vm.$set(_vm.value, "amount", _vm._n($$v))
              },
              expression: "value.amount"
            }
          }),
          _vm._v(" "),
          _c("small", { staticClass: "stan-text-danger error" }, [
            _vm._v(
              "\n\t\t\t\t" +
                _vm._s(_vm.price_validation_error_message) +
                "\n\t\t\t"
            )
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "price-wrapper",
          class: { "form-error": _vm.validation.sale_amount.$error }
        },
        [
          _c("div", [
            _c(
              "label",
              { staticClass: "control-label" },
              [
                _c("span", { staticClass: "mr-1" }, [
                  _vm._v(
                    _vm._s(_vm.$t("Discount Price")) +
                      "(" +
                      _vm._s(_vm.getCurrencySymbol(_vm.currency)) +
                      ")"
                  )
                ]),
                _vm._v(" "),
                _c("AppToggle", {
                  attrs: { val: _vm.value.sale_amount_available },
                  on: { valueChange: _vm.toggleDiscountAvailable }
                })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("AppInput", {
            attrs: {
              "input-class": "mb-1",
              disabled: !_vm.value.sale_amount_available,
              type: "number",
              hasPrecision: "",
              dataTestId: "sale-amount"
            },
            on: { blur: _vm.validation.$touch },
            model: {
              value: _vm.value.sale_amount,
              callback: function($$v) {
                _vm.$set(_vm.value, "sale_amount", _vm._n($$v))
              },
              expression: "value.sale_amount"
            }
          }),
          _vm._v(" "),
          _c("small", { staticClass: "stan-text-danger error" }, [
            _vm._v(" " + _vm._s(_vm.price_validation_error_message))
          ])
        ],
        1
      )
    ]),
    _vm._v(" "),
    _vm.recurring
      ? _c("div", { staticClass: "mb-3" }, [
          _c("div", [
            _c("label", { staticClass: "control-label text-truncate mb-0" }, [
              _vm._v(_vm._s(_vm.$t("Scheduling")))
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "text-sm" }, [
              _vm._v(
                _vm._s(
                  _vm.$t(
                    "Customize the duration and billing cycle of your membership"
                  )
                )
              )
            ])
          ])
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "price-input-section" }, [
      _vm.recurring
        ? _c(
            "div",
            {
              staticClass: "price-wrapper mb-3",
              class: { "form-error": _vm.validation.interval.$error }
            },
            [
              _c("div", [
                _c("label", { staticClass: "control-label mr-1" }, [
                  _vm._v(_vm._s(_vm.$t("Recurring *")))
                ])
              ]),
              _vm._v(" "),
              _c("AppDropdown", {
                staticClass: "form-control",
                attrs: {
                  searchable: false,
                  options: [
                    { label: "Yearly", value: "year" },
                    { label: "Monthly", value: "month" },
                    { label: "Weekly", value: "week" },
                    { label: "Daily", value: "day" }
                  ],
                  reduce: "value"
                },
                on: { blur: _vm.validation.interval.$touch },
                model: {
                  value: _vm.value.interval,
                  callback: function($$v) {
                    _vm.$set(_vm.value, "interval", $$v)
                  },
                  expression: "value.interval"
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.recurring && !_vm.hideCancelSubscription
        ? _c(
            "div",
            { staticClass: "price-wrapper mb-3" },
            [
              _c("div", [
                _c(
                  "label",
                  { staticClass: "control-label" },
                  [
                    _c("span", { staticClass: "mr-1" }, [
                      _vm._v(_vm._s(_vm.$t("Cancel subscription after")))
                    ]),
                    _vm._v(" "),
                    _c("AppToggle", {
                      attrs: { val: _vm.value.membership_duration_available },
                      on: { valueChange: _vm.toggleDurationAvailable }
                    })
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c("AppDropdown", {
                staticClass: "form-control h-auto px-2",
                attrs: {
                  searchable: false,
                  options: _vm.durationOptions,
                  reduce: "value",
                  disabled: !_vm.value.membership_duration_available
                },
                on: { blur: _vm.validation.$touch },
                model: {
                  value: _vm.value.membership_duration,
                  callback: function($$v) {
                    _vm.$set(_vm.value, "membership_duration", $$v)
                  },
                  expression: "value.membership_duration"
                }
              })
            ],
            1
          )
        : _vm._e()
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }